import React from 'react';

import { noop } from 'lodash';

import { ArrowIcon } from '../arrow-icon';

import { DeliveryAddressItem } from './delivery-address-item';
import { AddressList, AddressWrapper, LabelArrow, LabelTitle, LabelTitleWrapper } from './styled';
import { IDeliveryAddressesProps } from './types';

export const DeliveryAddressesList: React.FC<IDeliveryAddressesProps> = ({
  addresses,
  onAddressSelect,
  label,
  onTitleClick,
  onAddressDelete,
  onEditAddress = noop,
  collapsible = false,
  collapsed = false,
  showTitle = true,
  showEdit = true,
  showDelete = false,
}) => {
  return (
    <AddressWrapper>
      {showTitle && (
        <LabelTitleWrapper onClick={onTitleClick}>
          <LabelTitle>{label}</LabelTitle>
          {collapsible && <LabelArrow $collapsed={collapsed}>{ArrowIcon()}</LabelArrow>}
        </LabelTitleWrapper>
      )}
      {!collapsed && (
        <AddressList>
          {addresses.map((address, index) => (
            <DeliveryAddressItem
              key={index}
              address={address}
              showEdit={showEdit}
              showDelete={showDelete}
              onSelect={() => {
                onAddressSelect(address);
              }}
              onEdit={() => {
                onEditAddress(address);
              }}
              onDelete={() => {
                if (onAddressDelete) {
                  onAddressDelete(address);
                }
              }}
            />
          ))}
        </AddressList>
      )}
    </AddressWrapper>
  );
};
